import IntroductionSection from "./IntroductionSection.js";
import WhatIsMentalClaritySection from "./WhatIsMentalClaritySection.js";
import WhyMentalClarityMattersSection from "./WhyMentalClarityMattersSection.js";
import SignsYouLackMentalClaritySection from "./SignsYouLackMentalClaritySection.js";
import MentalClarityVsMindfulnessSection from "./MentalClarityVsMindfulnessSection.js";
import DailyHabitsSection from "./DailyHabitsSection.js";
import StressReducesClaritySection from "./StressReducesClaritySection.js";
import MentalClarityAtWorkSection from "./MentalClarityAtWorkSection.js";
import CalmMindsetSection from "./CalmMindsetSection.js";
import MentalClarityForLeadersSection from "./MentalClarityForLeadersSection.js";
import AhavibesPerspectiveSection from "./AhavibesPerspectiveSection.js";

const SECTION_COMPONENTS = {
  introduction: IntroductionSection,
  "what-is-mental-clarity": WhatIsMentalClaritySection,
  "why-mental-clarity-matters": WhyMentalClarityMattersSection,
  "signs-you-lack-mental-clarity": SignsYouLackMentalClaritySection,
  "mental-clarity-vs-mindfulness": MentalClarityVsMindfulnessSection,
  "daily-habits": DailyHabitsSection,
  "stress-reduces-clarity": StressReducesClaritySection,
  "mental-clarity-at-work": MentalClarityAtWorkSection,
  "a-calm-mindset": CalmMindsetSection,
  "mental-clarity-for-leaders": MentalClarityForLeadersSection,
  "ahavibes-perspective": AhavibesPerspectiveSection,
};

export default SECTION_COMPONENTS;
